<template>
  <div v-if="isLoading" class="preloader-overlay">
    <div class="preloader">
      <!-- Aquí puedes colocar tu animación o spinner -->
      <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="45" stroke="#00f" stroke-width="5" fill="none" />
        <circle cx="50" cy="50" r="45" stroke="#fff" stroke-width="5" fill="none" stroke-dasharray="283" stroke-dashoffset="75" />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

// Usamos Vuex para obtener el estado de isLoading
const store = useStore();
const isLoading = computed(() => store.state.isLoading);
</script>

<style scoped>
.preloader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.preloader svg {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
